module.exports = __webpack_public_path__ + "assets/img/customerService-d5741fb0.png";